import React from "react";
import FundCard from "../FundCard";
import "./style.scss";
import { TITAN_FUNDS, isGotitanPromoActive } from "../../utils/constants";

const calculateRangeDate = dateToCompare => {
  const date1 = new Date(dateToCompare);
  const date2 = new Date();
  const diffDays = Math.ceil(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24));

  return diffDays;
};

const FundList = ({ funds, tabs, currentTab, handleSelect, productType }) => {
  // Evaluate once per render so every card in the list sees a consistent value.
  const goTitanPromoActive = isGotitanPromoActive();
  return (
    <div className="funds">
      {(funds || [])
        .sort((a, b) => {
          const aEffectiveDate = calculateRangeDate(a.effectiveDate);
          const bEffectiveDate = calculateRangeDate(b.effectiveDate);

          const hasNoThreeAnnualReturnA = a.threeAnnualReturn === "0%";
          const hasNoThreeAnnualReturnB = b.threeAnnualReturn === "0%";

          // Check if the item is currently in the range between today and 7 days forward
          const inRangeA = aEffectiveDate >= 0 && aEffectiveDate <= 7;
          const inRangeB = bEffectiveDate >= 0 && bEffectiveDate <= 7;

          // Prioritize in-range items at the top
          if (inRangeA && !inRangeB) return -1;
          if (!inRangeA && inRangeB) return 1;

          // Prioritize GoTitan-applicable funds (only while the promo window is open)
          if (goTitanPromoActive) {
            const isTitanA = TITAN_FUNDS.includes(a.code);
            const isTitanB = TITAN_FUNDS.includes(b.code);
            if (isTitanA && !isTitanB) return -1;
            if (!isTitanA && isTitanB) return 1;
          }

          // Prioritize popular funds at top
          if (Number(a.isPopular) && !Number(b.isPopular)) return -1;
          if (!Number(a.isPopular) && Number(b.isPopular)) return 1;

          // Items with no threeAnnualReturn are placed at the bottom
          if (hasNoThreeAnnualReturnA && !hasNoThreeAnnualReturnB) return 1;
          if (!hasNoThreeAnnualReturnA && hasNoThreeAnnualReturnB) return -1;

          // If both items have no threeAnnualReturn and are in the range, compare by effectiveDate
          if (
            hasNoThreeAnnualReturnA &&
            hasNoThreeAnnualReturnB &&
            inRangeA &&
            inRangeB
          ) {
            if (aEffectiveDate > bEffectiveDate) return 1;
            if (bEffectiveDate > aEffectiveDate) return -1;
          }

          // Perform sorting logic based on threeAnnualReturn
          if (a.threeAnnualReturn !== "0%" && b.threeAnnualReturn !== "0%") {
            const threeAnnualReturnDiff =
              Number(b.threeAnnualReturn.replace("%", "")) -
              Number(a.threeAnnualReturn.replace("%", ""));

            if (threeAnnualReturnDiff !== 0) {
              return threeAnnualReturnDiff;
            }
          }

          // If threeAnnualReturn is zero or not valid, compare by effectiveDate
          if (aEffectiveDate > bEffectiveDate) return 1;
          if (bEffectiveDate > aEffectiveDate) return -1;

          // If effectiveDate is also the same, compare by name
          return a.name.localeCompare(b.name);
        })
        .map((item, idx) => (
          <FundCard
            key={idx}
            index={tabs.indexOf(currentTab)}
            fundName={item.name}
            annualReturn={
              item.threeAnnualReturn &&
              item.threeAnnualReturn !== "0%" &&
              item.threeAnnualReturn
            }
            fundInfoUrl={item.fundInfoUrl}
            assetClass={item.assetClass}
            isSyariah={Number(item.isSyariahFund) > 0}
            isNewFund={calculateRangeDate(item.effectiveDate) <= 7}
            onSelect={handleSelect(item)}
            details={item.details}
            productType={productType}
            isPopular={!!Number(item.isPopular)}
            isGotitanApplicable={
              goTitanPromoActive && TITAN_FUNDS.includes(item.code)
            }
          />
        ))}
    </div>
  );
};

export default FundList;
